import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {
  Grid,
  Card,
  Accordion,
  Icon,
  Segment,
  Placeholder,
  Popup,
  Loader,
} from "semantic-ui-react";
import PercentageBar from "./PercentageBar";
import CustomToaster from "../../components/CustomToaster";
import { useDispatch, useSelector } from "react-redux";
import { getSummarizationDocUrl,successSummarizationDocUrl } from "../../actions/dataConsoleAction";
import PDFViewer from "../Dataconsole/PDFViewer";
import DropLoader  from '../../components/DropLoader';

const Summarization = ({ summarydata, listLength, title }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [toasterVisible, setToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [toasterAppearance, setToasterAppearance] = useState("success");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewDocUrl, setPreviewDocUrl] = useState("");
  const [PreviewDocFilename, setPreviewDocFilename] = useState("");
  const [isLoading, setIsLoading] = useState(false); // State for loader
  const queryParams = new URLSearchParams(location.search);
  const datasetId = queryParams.get("c");
  const dispatch = useDispatch();
  const { summaryDocUrlData, summaryDocUrlStatus } = useSelector(
    (state) => state.saveSummaryDocUrl || {}
  );

  const customComponents = {
    h1: ({ children }) => <h1 style={{ fontWeight: 'bold', color: '#000000D9' }}>{children}</h1>,
    h2: ({ children }) => <h2 style={{ fontWeight: 'bold', color: '#000000D9' }}>{children}</h2>,
    h3: ({ children }) => <h3 style={{ fontWeight: 'bold', color: '#000000D9' }}>{children}</h3>,
    h4: ({ children }) => <h4 style={{ fontWeight: 'bold', color: '#000000D9' }}>{children}</h4>,
    h5: ({ children }) => <h5 style={{ fontWeight: 'bold', color: '#000000D9' }}>{children}</h5>,
    p: ({ children }) => (
      <p style={{ fontSize: '14px', lineHeight: '1.5', color: '#000000ad', margin: '7px 0px 0px' }}>
        {children}
      </p>
    ),
    ul: ({ children }) => (
      <ul style={{ listStyleType: 'disc', marginLeft: '20px', marginTop: '5px' }}>
        {children}
      </ul>
    ),
    ol: ({ children }) => (
      <ol style={{ listStyleType: 'decimal', marginLeft: '20px', marginTop: '5px' }}>
        {children}
      </ol>
    ),
    li: ({ children }) => {
      // If children is a string, handle it directly
      if (typeof children === 'string') {
        return (
          <li style={{ marginBottom: '5px' }}>
            <span style={{ color: '#000000D9', fontSize: '14px' }}>{children}</span>
          </li>
        );
      }

      // If children is an array or an object, split it into parts safely
      if (Array.isArray(children)) {
        return (
          <li style={{ marginBottom: '5px' }}>
            <span style={{ color: '#000000D9', fontSize: '14px' }}>{children[0]}</span>
            <span style={{ color: '#000000ad', fontSize: '14px' }}>{children.slice(1)}</span>
          </li>
        );
      }

      // Fallback if children is not a string or array (or handle other cases)
      return (
        <li style={{ marginBottom: '5px' }}>
          <span style={{ color: '#000000D9', fontSize: '14px' }}>{children}</span>
        </li>
      );
    },

  };

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  };

  const showToaster = (message, appearance) => {
    setToasterVisible(true);
    setToasterMessage(message);
    setToasterAppearance(appearance);
  };

  const closeToaster = () => {
    setToasterVisible(false);
  };

  useEffect(() => {
    if (summaryDocUrlStatus) {
      const fileUrl = summaryDocUrlData.downloadUrl;
      setPreviewDocUrl(fileUrl);
      setIsModalOpen(true);
      setIsLoading(false); // Hide loader when document is ready
      dispatch(successSummarizationDocUrl([]));
    }
  }, [summaryDocUrlData, summaryDocUrlStatus]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handlePreview = (item) => () => {
    console.log("preview ");
    const { fileName } = item;
    setPreviewDocFilename(fileName);
    setIsLoading(true); // Show loader when image is clicked
    dispatch(getSummarizationDocUrl(fileName, datasetId));
  };

  const handleCopyContent = (fileName, summary) => () => {
    const textToCopy = `File Name: ${fileName}\nSummary: ${summary}`;
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setToasterVisible(true);
        showToaster("Content copied to clipboard!", "success");
      })
      .catch((err) => {
        console.error("Failed to copy content: ", err);
      });
  };

  return (
    <>
      {toasterVisible && (
        <CustomToaster
          message={toasterMessage}
          duration={3000}
          onClose={closeToaster}
          position="right-top"
          appearance={toasterAppearance}
        />
      )}
      <Grid columns={1} stackable fluid>
        <div className="summarization-outer" style={{ width: "100%" }}>
          <PercentageBar summaryData={summarydata} listLength={listLength > 0 ? listLength : 0} />
        </div>
        <Grid.Column className="summarization-outer-header">
          <Card className="summarization-card-style">
            <Card.Content>
              <Card.Header>Dataset: {title}</Card.Header>
            </Card.Content>
          </Card>
        </Grid.Column>
        {summarydata.length > 0 ? (
          summarydata.map((item, index) => (
            <>
              <Grid.Column key={index} className="summarization-outer">
                <Card className="summarization-card-style">
                  <Card.Content>
                    <Card.Header>{item.fileName}</Card.Header>
                    <Card.Description>
                      <ReactMarkdown components={customComponents} remarkPlugins={[remarkGfm]} >{item.summary}</ReactMarkdown>
                    </Card.Description>
                  </Card.Content>
                </Card>
                <div className="image-container-summary">
                  <p>
                    {" "}
                    {isLoading ? (
                      <Loader active inline="centered" size="mini" />
                    ) : (
                      <Popup
                        content="Preview"
                        trigger={
                          <img
                            onClick={handlePreview(item)}
                            src="/images/preview-grey-icon.svg"
                            alt="Copy"
                          />
                        }
                      />
                    )}
                  </p>
                  <p>
                    {" "}
                    <Popup
                      content="Copy"
                      trigger={
                        <img
                          onClick={handleCopyContent(
                            item.fileName,
                            item.summary
                          )}
                          src="/images/copy-grey-icon.svg"
                          alt="Copy"
                        />
                      }
                    />
                  </p>
                </div>
              </Grid.Column>
            </>
          ))
        ) : (
          <>
            {Array.from({ length: 10 }).map((_, index) => (
              <Grid.Column key={index} className="summarization-outer">
                <Card className="lazy-loading-card-style">
                  <Card.Content>
                    <Placeholder>
                      <Placeholder.Header>
                        <Placeholder.Line length="very short" />
                        <Placeholder.Line length="medium" />
                      </Placeholder.Header>
                    </Placeholder>
                  </Card.Content>
                </Card>
              </Grid.Column>
            ))}
          </>
        )}
      </Grid>
      <PDFViewer
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        url={previewDocUrl}
        filename={PreviewDocFilename}
      />
    </>
  );
};

export default Summarization;
